import { PreviewYamlProps } from '../types';
import { YamlObjectContainer } from './_components/YamlObjectContainer';
import { YamlRawContainer } from './_components/YamlRawContainer';

export const YamlContainer = (props: PreviewYamlProps) => {
  const { renderMode, data } = props;
  const isRawMode = renderMode === 'raw' && typeof data === 'string';

  if (isRawMode) {
    return <YamlRawContainer {...props} />;
  }

  return <YamlObjectContainer {...props} />;
};
